export default __webpack_public_path__ + "static/logo_PZW_z_R-05b5d09baf8e337331127201e1fec4d8.jpg";